import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Input} from "shared/ui";
import {EyeVisible} from "shared/assets/svgs/EyeVisibleOutlined";
import {EyeInvisible} from "shared/assets/svgs/EyeInvisibleOutlined";

type Value = {
  username: string;
  password: string;
};

type Props = {
  onSignin: (username: string, password: string) => void;
};

const LoginForm = ({onSignin}: Props) => {
  const {t} = useTranslation(["login"]);
  const [passVisible, setPassVisible] = useState(false)
  
  const [values, setValues] = useState<Value>({
    username: "", password: "",
  });
  
  const handleChangeValue = (key: keyof Value) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;
    setValues((prev) => ({
      ...prev, [key]: nextValue,
    }));
  };
  
  const handleSignin = () => {
    if (!values.password) {
      return;
    }
    
    onSignin(values.username, values.password);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSignin();
    }
  };
  
  return (<div
    className={"form"}
    data-cy="loginForm"
  >
    <div className={"title"}>{t("login.title")}</div>
    <div className={"item"}>
      <Input
        autoComplete={"off"}
        size={"lg"}
        value={values.username}
        onChange={handleChangeValue("username")}
        onKeyDown={handleKeyDown}
        placeholder={t("login.input.phone")}
        data-cy="username"
      />
    </div>
    <div className={"item"}>
      <Input
        autoComplete={"off"}
        size={"lg"}
        type={passVisible ? "text" : "password"}
        value={values.password}
        onChange={handleChangeValue("password")}
        onKeyDown={handleKeyDown}
        placeholder={t("login.input.code")}
        data-cy="password"
        icon={<Button
          variant={"text"}
          size={"icon"}
          type="button"
          onClick={() => setPassVisible(v => !v)}>
          {passVisible ? <EyeVisible /> : <EyeInvisible />}
        </Button>}
      />
    </div>
    <div className={"mt-8"}>
      <Button
        variant={"primary"}
        size={"lg"}
        className={"button"}
        onClick={handleSignin}
        disabled={!values.password}
        data-cy="login"
      >
        {t("login.btn.phone")}
      </Button>
    </div>
  </div>);
};

export default LoginForm;
